import React, { useEffect, useState, memo } from 'react';
import { useForm } from 'react-hook-form';
import AddNewTeamStyles from '../../../AddNewTeam/AddNewTeam.styles';
import { Box, Button, Typography } from '@mui/material';
import CustomDialog from '../../../../../../global/components/CustomModal/CustomModal';
import { ReactComponent as CloseIcom } from '../../../../../../assets/icons/close.svg';

const GenerateCode = (props: any) => {
  console.log(props,"props")
  const classes = AddNewTeamStyles;
  const { register, handleSubmit, formState } = useForm();
  const errors = formState.errors;
  const onSubmit = (data: any) => console.log("data", data);
  const [editFormData, setFormData] = useState([]);

  useEffect(() => {
    if (props.items !== undefined) {
      setFormData(props.items);
    }
  }, [props.items]);

  const handleClose = () => {
    props.handleCloseAddTeam();
  }

  const dialogHeaderContent = () => {
    return (
      <Box marginTop={1} marginRight={3} sx={{ cursor: 'pointer' }}>
        <CloseIcom onClick={handleClose} />
      </Box>
    );
  };

  const getCode = (dt: any) => {
    let txt = ``;
    switch (dt.type) {
      case 'text':
        return <Box>
          <label>{dt.name?dt.name:dt.type}: </label>
          <input type="text" placeholder={dt?.placeholder?dt?.placeholder:dt.type} {...register(dt?.name, { 'required': dt?.required })} />
          {errors[dt?.name] && (
            <Typography>This is required.</Typography>
          )}
        </Box>
        break;
      case 'radio':
        return <Box>
          <label>{dt.name}: </label>
          {dt.options.split(";").map((e: any) => {
            return <><input type="radio" value={e} placeholder={dt.placeholder} {...register(dt.name, { 'required': dt.required })} /><label>{e} </label></>
          })}
          {errors[dt.name] && (
            <Typography>This is required.</Typography>
          )}
        </Box>
        break;
      case 'select':
        return <Box>
          <label>{dt.name}: </label>
          <select {...register(dt.name, { required: dt.required })}>
            {dt.options.split(";").map((e: any) => {
              return <option value={e}>{e}</option>
            })}
          </select>
          {errors[dt.name] && (
            <Typography>This is required.</Typography>
          )}
        </Box>
        break;
      case 'checkbox':
        return <Box>
          <label>{dt.name}: </label>
          <input type="checkbox" placeholder={dt.placeholder} {...register(dt.name, { 'required': dt.required })} />
          {errors[dt.name] && (
            <Typography>This is required.</Typography>
          )}
        </Box>
        break;
      case 'textarea':
        return <Box>
          <label>{dt.name}: </label>
          <textarea {...register(dt.name, { 'required': dt.required })} />
          {errors[dt.name] && (
            <Typography>This is required.</Typography>
          )}
        </Box>
        break;
      default:
        txt += "AAAAAAAAAA"
    }
    return txt;
  }

  const dialogTitleContent = () => {
    return (
      <>
        <Box sx={classes.profileWrapper}>
          <form onSubmit={handleSubmit(onSubmit)}>
            {generateHtml()}
            <Box>
              <Button type="submit" variant="outlined">Save</Button>
            </Box>
          </form>
        </Box>
      </>
    );
  };

  const generateHtml = () => {
    return (
      Array.isArray(editFormData) && editFormData.length > 0 ?
        editFormData.map((e: any) => {
          return getCode(e)
        }) : ""
    )
  }
  return (
    <>
      <CustomDialog
        fullScreen={true}
        isDialogOpen={props.isDialogOpen}
        dialogHeaderContent={dialogHeaderContent()}
        dialogTitleContent={dialogTitleContent()}
        handleDialogClose={props.handleCloseAddTeam}
      />
    </>
  );
}

export default GenerateCode
